
import MainFormulaModalView from 'common-views/MainFormulaModalView';

class ReportFilterFormulaModalView extends MainFormulaModalView {

    validateParameterType(paramType) {

        $(".argumentOption").val("");
        $(".argumentOption").prop('disabled', 'disabled');
        $(".functionValueRadio").attr('disabled', true);

        $("#fieldRadioFormula").attr('disabled', false);

        let radioButton = $("#textRadioFormula");
        let input = $("#TextValue");

        switch(paramType){
            case 'Number':
            case 'Amount':
            case 'Start index':
            case 'Length':
            case 'Digits':
            case 'Source number':
            case 'Power':
                input = $("#NumberValue");
                radioButton = $("#numberRadioFormula");
                this.enableNumberValue();
                break;
            case 'Date':
            case 'Date 1':
            case 'Date 2':
                input = $("#DateValue");
                radioButton = $("#dateRadioFormula");
                this.enableDateValue();
                break;
            default:               
                this.enableTextValue();
                break;
        }

        input.attr('disabled', false);
        radioButton.attr('disabled', false);
        radioButton.prop('checked', 'checked');
    }

    getDataType(caption, inputName){

        const selectedValue = $('#' + inputName + " option:selected");
        const dataType = selectedValue.data("type");
               
        return dataType;
    }



   
}

export default ReportFilterFormulaModalView;
